export default {
  countries: {
    'The Kingdom of Bahrain': '🇧🇭 Bahrain',
    'The Arab Republic of Egypt': '🇪🇬 Egypt',
    'The State of Kuwait': '🇰🇼 Kuwait',
    'Sultanate of Oman': '🇴🇲 Oman',
    'The State of Qatar': '🇶🇦 Qatar',
    'Kingdom of Saudi Arabia': '🇸🇦 Saudi Arabia',
    'The United Arab Emirates': '🇦🇪 UAE'
  },
  labels: {
    selectCountry: 'Select Country',
    chooseLanguage: 'Choose Language',
    searchStores: 'Search stores...',
    recent: 'Recent',
    clearAll: 'Clear All',
    noCodesFound: 'No codes found',
    contactUs: 'Contact Us'
  },
  categories: {
    all: 'All',
    abaya: 'Abaya',
    babies: 'Babies',
    beauty: 'Beauty',
    bookings: 'Bookings',
    cars: 'Cars',
    coffeeAndSweets: 'Coffee & Sweets',
    delivery: 'Delivery',
    electronics: 'Electronics',
    fashion: 'Fashion',
    flowers: 'Flowers',
    furniture: 'Furniture',
    games: 'Games',
    gifts: 'Gifts',
    groceries: 'Groceries',
    health: 'Health',
    home: 'Home',
    jewelry: 'Jewelry',
    oud: 'Oud',
    perfumes: 'Perfumes',
    pet: 'Pet',
    restaurants: 'Restaurants',
    services: 'Services',
    shoes: 'Shoes',
    sports: 'Sports',
    water: 'Water'
  },
  actions: {
    copied: 'Code Copied!',
    copy_code: 'Copy Code'
  },
  landing: {
    heroTitle: 'Save more every time you shop.',
    heroDescription: 'Blupon is the first coupons community in the Middle East.\nDiscover the latest community-verified promo codes for hundreds of online stores.',
    downloadPrompt: 'Download the app today!'
  }
  ,
  savings: {
    sectionTitle: 'Your Everyday Savings Companion',
    cards: [
      {
        title: 'Thousands of Promo Codes',
        description: 'Thousands of promo codes, hundreds of stores, and daily updates.'
      },
      {
        title: 'Community-Powered',
        description: 'Post your own promo codes to help everyone save.'
      },
      {
        title: 'One-Tap Copy',
        description: 'Use your favorite code instantly at checkout. No ads, no hassle.'
      },
      {
        title: 'Save Favorites',
        description: 'Follow your go-to brands and never miss a discount.'
      },
      {
        title: 'Smart Alerts',
        description: 'Get notified when new coupons drop for your favorite stores.'
      }
    ]
  },
  steps: {
    sectionTitle: 'Shop Smarter in 3 Easy Steps',
    cards: [
      {
        title: 'Discover Deals You Can Trust',
        description: 'Explore the latest, community-verified promo codes for your favorite stores.'
      },
      {
        title: 'Copy & Save Instantly',
        description: 'Found a code? Tap once to copy and use it right at checkout.'
      },
      {
        title: 'Share to Help Others Save',
        description: 'Post your own promo codes and grow Blupon\'s saving community.'
      }
    ]
  },
  graphics: {
    items: [
      { title: 'Local Offers', description: 'Find promo codes for your favorite stores.' },
      { title: 'Verified by the Community', description: 'See feedback from real shoppers.' },
      { title: 'Quick & Easy', description: 'Copy promo codes with one tap - no ads, no spam.' }
    ]
  ,
  sectionTitle: 'The Easiest Way to Save Across the Middle East'
  }
  ,
  built: {
    sectionTitle: 'Built by Shoppers, for Shoppers',
    items: [
      { number: '50,000+', title: 'Saved by Blupon users' },
      { number: '6+', title: 'Middle Eastern Countries including: Saudi Arabia, UAE, Egypt and more' },
      { number: '2,000+', title: 'Coupons for hundreds\nof online stores and brands.' }
    ],
    cta: 'Get Started Today!'
  },
  feature: {
    title: 'Download Blupon App',
    description: 'Join the first coupon community in the Middle East and start saving.\nDownload Blupon app and discover thousands of verified coupons for hundreds of online stores.',
    downloadLabel: 'Download on',
    followLabel: 'Follow Us On Social Media',
    terms: 'Terms & Conditions',
    privacy: 'Privacy Policy'
  }
};